const canonicalSiteUrl = "https://join-a.no";

export function siteUrl(): string {
  const configured = import.meta.env.VITE_SITE_URL?.trim();
  if (configured) return configured.replace(/\/+$/, "");

  return canonicalSiteUrl;
}

export function inviteUrl(token: string): string {
  return `${siteUrl()}/i/${encodeURIComponent(token)}`;
}

export function planUrl(token: string): string {
  return `${siteUrl()}/p/${encodeURIComponent(token)}`;
}

export function gjengUrl(token: string): string {
  return `${siteUrl()}/g/${encodeURIComponent(token)}`;
}

const pendingInviteStorageKey = "join.pendingInvite";

export function rememberPendingInvite(token: string): void {
  try {
    window.localStorage.setItem(pendingInviteStorageKey, token);
  } catch {
    // Ignore storage failures (private mode, disabled storage).
  }
}

export function consumePendingInvite(): string | null {
  try {
    const token = window.localStorage.getItem(pendingInviteStorageKey);
    if (token) window.localStorage.removeItem(pendingInviteStorageKey);
    return token;
  } catch {
    return null;
  }
}

export function peekPendingInvite(): string | null {
  try {
    return window.localStorage.getItem(pendingInviteStorageKey);
  } catch {
    return null;
  }
}

const guestPlanStorageKey = "join.guestPlan";
const guestGjengStorageKey = "join.guestGjeng";

// Remember the plan link a guest joined through, so we can route them back to it
// (and to the upgrade nudge) on later visits within the same anonymous session.
export function rememberGuestPlan(token: string): void {
  try {
    window.localStorage.setItem(guestPlanStorageKey, token);
  } catch {
    // Ignore storage failures (private mode, disabled storage).
  }
}

export function peekGuestPlan(): string | null {
  try {
    return window.localStorage.getItem(guestPlanStorageKey);
  } catch {
    return null;
  }
}

export function forgetGuestPlan(): void {
  try {
    window.localStorage.removeItem(guestPlanStorageKey);
  } catch {
    // Ignore storage failures.
  }
}

export function rememberGuestGjeng(token: string): void {
  try {
    window.localStorage.setItem(guestGjengStorageKey, token);
  } catch {
    // Ignore storage failures (private mode, disabled storage).
  }
}

export function peekGuestGjeng(): string | null {
  try {
    return window.localStorage.getItem(guestGjengStorageKey);
  } catch {
    return null;
  }
}

export function forgetGuestGjeng(): void {
  try {
    window.localStorage.removeItem(guestGjengStorageKey);
  } catch {
    // Ignore storage failures.
  }
}

export async function shareOrCopy(payload: ShareData): Promise<"shared" | "copied"> {
  if (navigator.share && navigator.canShare?.(payload)) {
    await navigator.share(payload);
    return "shared";
  }

  const text = payload.url || [payload.title, payload.text].filter(Boolean).join("\n");
  await navigator.clipboard.writeText(text || "");
  return "copied";
}
